import { useState } from 'react';
import api from '../../../Api'
import { useNavigate } from 'react-router-dom';

export const useRazorpayPayment = () => {
  const [paymentStep, setPaymentStep] = useState('idle'); // idle | creating | processing | completed | failed
  const [paymentError, setPaymentError] = useState(null);
  const navigate = useNavigate();

  // Create Razorpay order
  const createRazorpayOrder = async (bookingId, amount) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await api.post(
        `/wedding/bookings/${bookingId}/razorpay-order`,
        { amount, payment_type: 'full' },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const result = response.data;
      if (result.status) {
        return result.data; // { order_id, key_id, amount_paise, currency, prefill, ... }
      } else {
        throw new Error(result.message || 'Failed to create payment order.');
      }
    } catch (err) {
      throw new Error(err.message || 'Payment order creation failed.');
    }
  };

  // Verify payment
  const verifyPayment = async (bookingId, paymentId, orderId, signature) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await api.post(
        `/wedding/bookings/${bookingId}/razorpay-verify`,
        {
          razorpay_payment_id: paymentId,
          razorpay_order_id: orderId,
          razorpay_signature: signature,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const result = response.data;
      if (result.status) {
        return result.data;
      } else {
        throw new Error(result.message || 'Payment verification failed.');
      }
    } catch (err) {
      throw new Error(err.message || 'Payment verification failed.');
    }
  };

  // Open Razorpay checkout
  const openRazorpayCheckout = (orderData, bookingId, prefillData, onSuccess, onDismiss) => {
    const options = {
      key: orderData.key_id,
      amount: orderData.amount_paise,
      currency: orderData.currency,
      name: 'Jayraj Group Wedding',
      description: `Booking #${bookingId}`,
      order_id: orderData.order_id,
      prefill: {
        name: prefillData?.name || '',
        email: prefillData?.email || '',
        contact: prefillData?.contact || '',
      },
      theme: { color: '#d4a359' },
      modal: {
        ondismiss: () => {
          setPaymentStep('idle');
          if (onDismiss) onDismiss();
        },
      },
      handler: async (response) => {
        setPaymentStep('processing');
        try {
          const verifiedData = await verifyPayment(
            bookingId,
            response.razorpay_payment_id,
            response.razorpay_order_id,
            response.razorpay_signature
          );
          setPaymentStep('completed');
          if (onSuccess) onSuccess(verifiedData);
            navigate("/profile/destination-wedding");
        } catch (err) {
          setPaymentStep('failed');
          setPaymentError(err.message);
        }
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
    setPaymentStep('processing');
  };

  // Start payment flow
  const initiatePayment = async (bookingId, amount, prefillData, onSuccess, onDismiss) => {
    setPaymentStep('creating');
    setPaymentError(null);
    try {
      const orderData = await createRazorpayOrder(bookingId, amount);
      openRazorpayCheckout(orderData, bookingId, prefillData, onSuccess, onDismiss);
    } catch (err) {
      setPaymentStep('failed');
      setPaymentError(err.message);
    }
  };

  return {
    paymentStep,
    paymentError,
    initiatePayment,
    resetPayment: () => { setPaymentStep('idle'); setPaymentError(null); }
  };
};